import React, { useEffect } from 'react';

export default function Lightbox({ items = [], startIndex = 0, onClose }){
  const [idx, setIdx] = React.useState(startIndex || 0);
  useEffect(()=>{ setIdx(startIndex || 0); }, [startIndex]);
  useEffect(()=>{
    function onKey(e){ if(e.key === 'Escape') onClose(); if(e.key === 'ArrowRight') setIdx(i=>Math.min(i+1, items.length-1)); if(e.key === 'ArrowLeft') setIdx(i=>Math.max(i-1,0)); }
    window.addEventListener('keydown', onKey); return ()=>window.removeEventListener('keydown', onKey);
  }, [items, onClose]);
  if(!items || items.length === 0) return null;
  const cur = items[idx] || {};
  return (
    <div className="lb-backdrop" onClick={(e)=>{ if(e.target === e.currentTarget) onClose(); }}>
      <div className="lb-inner">
        <button className="lb-close" onClick={onClose}>✕</button>
        <div className="lb-media">
          {cur.mime && cur.mime.startsWith('image/') && <img src={cur.url || cur.path} alt={cur.filename || ''} />}
          {cur.mime && cur.mime.startsWith('video/') && <video src={cur.url || cur.path} controls autoPlay />}
          {(!cur.mime || (!cur.mime.startsWith('image/') && !cur.mime.startsWith('video/'))) && <a href={cur.url || cur.path} target="_blank" rel="noreferrer">{cur.filename || 'Tệp'}</a>}
        </div>
        <div className="lb-controls">
          <button disabled={idx===0} onClick={()=>setIdx(i=>Math.max(0, i-1))}>‹ Prev</button>
          <div className="lb-counter">{idx+1} / {items.length}</div>
          <button disabled={idx===items.length-1} onClick={()=>setIdx(i=>Math.min(items.length-1, i+1))}>Next ›</button>
        </div>
      </div>
    </div>
  );
}
